export default "__VITE_PUBLIC_ASSET__8cb8d5b1__"